import { render, staticRenderFns } from "./ScPwdSalesBookV2.vue?vue&type=template&id=0550c592&"
import script from "./ScPwdSalesBookV2.vue?vue&type=script&lang=js&"
export * from "./ScPwdSalesBookV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports